import React from "react";
import DocList from "../../_components/Sales/SalesDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome, FiSlash } from "react-icons/fi";
import { T, fmtCurrency } from "../../_components/Sales/SalesShared";
import { getQuotations, getQuotationKpis, deleteQuotation, getQuotationById } from "../../_services/sales.service";
import { isBusinessUnitManager, isSuperAdmin, canAccessAccounting } from '../../utils/roleConstants';

export default function Quotations() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // BUM can only view — hide create button
    const viewOnly = isBusinessUnitManager(user) && !canAccessAccounting(user) && !isSuperAdmin(user);
    return (
        <DocList
            docType="Quotation"
            basePath="/sales/quotations"
            fetchList={getQuotations}
            bulkPrint={{ fetchById: getQuotationById }}
            fetchKpis={getQuotationKpis}
            deleteItem={deleteQuotation}
            hideCreate={viewOnly}
            viewOnly={viewOnly}
            showExpiry
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected", "Cancelled"]}
            kpiCards={[
                { label: "Total Quotations", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
                { label: "Cancelled", key: "cancelled", icon: FiSlash, color: T.textMuted },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiHome, label: "Company Name", key: "customer" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v, row) => fmtCurrency(v, row.currency) },
                { icon: FiCreditCard, label: "Payment Terms", key: "paymentTerms" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "Quo No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "customer", label: "Company Name" },
            ]}
        />
    );
}